<template>
  <div class="about">
    <div class="wrap">
      <div class="top-section">
        <div class="spacer">
          <br />
        </div>
        <div id="about" class="star-background">
          <div class="page-container">
            <div class="flex-col-1-1-vertical-center content">
              <div class="text-content">
                <h2>{{ $t('home.about-mew.title') }}</h2>
                <p class="color-white">{{ $t('home.about-mew.text') }}</p>
              </div>
              <div class="image-content">
                <img
                  :alt="$t('common.mew-icon')"
                  class="mew-icon"
                  src="~@/assets/images/home/creator_icon.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-section">
        <div class="page-container">
          <div class="grid-col-2 mew-features d-flex justify-content-center">
            <dir class="content">
              <div class="image">
                <img src="~@/assets/images/home/icon-wallet.svg" alt />
              </div>
              <div class="text">
                <h3>{{ $t('home.join-mew.title') }}</h3>
                <p>{{ $t('home.join-mew.text') }}</p>
              </div>
            </dir>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import 'AboutContainer-desktop.scss';
@import 'AboutContainer-tablet.scss';
@import 'AboutContainer-mobile.scss';
</style>
